// extracted by mini-css-extract-plugin
export var button = "PaqueteItem-module--button--hFk6J";
export var image = "PaqueteItem-module--image--RhnF9";
export var paqueteWrapper = "PaqueteItem-module--paquete-wrapper--IhK8x";